import { useCreatorFilter } from './use-creator-filter';
import { useSearchFilter } from './use-search-filter';
import { useStatusFilter } from './use-status-filter';
import { useTypeFilter } from './use-type-filter';
export var useTableFilters = function () {
    var searchFilter = useSearchFilter().searchFilter;
    var _a = useStatusFilter(), statusFilter = _a.statusFilter, setStatusFilter = _a.setStatusFilter;
    var _b = useTypeFilter(), typeFilter = _b.typeFilter, setTypeFilter = _b.setTypeFilter;
    var _c = useCreatorFilter(), creatorFilter = _c.creatorFilter, setCreatorFilter = _c.setCreatorFilter;
    var filterState = {
        searchFilter: searchFilter,
        statusFilter: statusFilter,
        typeFilter: typeFilter,
        creatorFilter: creatorFilter,
    };
    return {
        filterState: filterState,
        setStatusFilter: setStatusFilter,
        setTypeFilter: setTypeFilter,
        setCreatorFilter: setCreatorFilter,
    };
};
